import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { CustomerAuthHistoryModel, CustomerAuthModel, CustomerAuthTokenModel } from '../../../models/customer.model';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { CustomersAdminService } from '../../../services/customer/customers-admin.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kv-customers-auth-admin-form',
  template: `

    <div class="ui-g-12 text-right">

      <button pButton type="button" class="k-generic-btn" icon="fa fa-chevron-left"
              iconPos="left" label="{{ 'common.back' | translate }}"
              (click)="_onBack($event)"
      ></button>


    </div>
    <div class="Customers ui-g-12 form-group master-data" style="width: 100%" *ngIf="customerAuth">
      <div class="k-row">
        <div [kv-form-element]="{ label: 'customers.auth_admin_id', md: '4'}">
          <label>{{customerAuth.id}}</label>
        </div>
        <div [kv-form-element]="{ label: 'customers.auth_admin_customer_id', md: '4'}">
          {{customerAuth.customer_id}}
        </div>
        <div [kv-form-element]="{ label: 'customers.auth_admin_account_type', md: '4'}">
          {{customerAuth.account_type_host_id}} - {{customerAuth.account_type_description}} 
        </div>
      </div>

      <div class="k-row">
        <div [kv-form-element]="{ label: 'customers.auth_admin_user_account', md: '4'}">
          <form [formGroup]="loginForm" (submit)="updateLogin()">
            <input style="width: 80%;" formControlName="user_account" pInputText type="text" [required]="true">
            <p-button [disabled]="!loginForm.valid" type="submit" pTooltip="{{ 'common.save' | translate }}" icon="fa fas fa-save"  styleClass="ui-button-info" ></p-button>
          </form>
        </div>
        <div [kv-form-element]="{ label: 'customers.auth_admin_ts_user_account_update', md: '4'}">
          {{customerAuth.ts_user_account_update | date: 'yyyy-MM-dd'}}
        </div>
        <div [kv-form-element]="{ label: 'customers.auth_admin_password_end_date', md: '4'}">
          {{customerAuth.password_end_date | date:'yyyy-MM-dd'}}
        </div>
      </div>

      <div class="k-row">
        <div [kv-form-element]="{ label: 'customers.auth_admin_ts_password_update', md: '4'}">
          {{customerAuth.ts_password_update | date: 'yyyy-MM-dd'}}
        </div>
        <div [kv-form-element]="{ label: 'customers.auth_admin_source_system', md: '4'}">
          {{customerAuth.source_system_host_id}}
        </div>
        <div [kv-form-element]="{ label: 'customers.auth_admin_status', md: '4'}">
          <span>{{ ('customers.auth_' + this.svcCustomerAdmin.getFlagKey(this.customerAuthData['flg_state'])) | translate }}</span>
        </div>



      </div>

      <app-kontable #table
                    title = "{{ 'common.customers_history' | translate }}"
                    [columns] = "[ 'id', 'account_type_host_id', 'user_account','flg_state',
                    { field: 'ts_ins', bodyTemplate: ts_ins, title: 'common.ts_ins' },
                    { field: 'ts_upd', bodyTemplate: ts_ins, title: 'common.ts_upd' },
                    { field: 'ts_del', bodyTemplate: ts_ins, title: 'common.ts_del' }
                     ]"
                    [titles] = "[ '#', 'customers.auth_host_id', 'customers.auth_user_account', 'common.status' ]"
                    [showDetailsButton]="false"
                    [showInfoButton]="false"
                    [showEditButton]="false"
                    [showDeleteButton]="false"
                    [showIncludeDeleted]="false"
                    [paginationType]="pt"
                    [showGlobalFilter]="false"
                    [source]="customerAuthHistory">
        <ng-template let-row #ts_ins>
          {{row['ts_ins'] | date: 'YYYY-MM-DD' }}
        </ng-template>
        <ng-template let-row #ts_upd>
          {{row['ts_upd'] | date: 'YYYY-MM-DD' }}
        </ng-template>
        <ng-template let-row #ts_del>
          {{row['ts_del'] | date: 'YYYY-MM-DD' }}
        </ng-template>

      </app-kontable>

      <app-kontable #table
                    title = "{{ 'common.customers_tokens' | translate }}"
                    [columns] = "[ 'id', 'token', 'token_type',
                    { field: 'ts_expiry', bodyTemplate: ts_expiry, title: 'customers.auth_token_expiry' },
                    'flg_state',
                    { field: 'ts_ins', bodyTemplate: ts_ins, title: 'common.ts_ins' },
                    { field: 'ts_upd', bodyTemplate: ts_ins, title: 'common.ts_upd' },
                    { field: 'ts_del', bodyTemplate: ts_ins, title: 'common.ts_del' }
                     ]"
                    [titles] = "[ '#', 'customers.auth_token', 'customers.auth_token_type', 'common.status' ]"
                    [showDetailsButton]="false"
                    [showInfoButton]="false"
                    [showEditButton]="false"
                    [showDeleteButton]="false"
                    [showIncludeDeleted]="false"
                    [showGlobalFilter]="false"
                    [showRecoverButton]="false"
                    [source]="customerAuthTokens">
        <ng-template let-row #ts_expiry>
          {{row['ts_expiry'] | date: 'yyyy-MM-dd' }}
        </ng-template>
        <ng-template let-row #ts_ins>
          {{row['ts_ins'] | date: 'yyyy-MM-dd' }}
        </ng-template>
        <ng-template let-row #ts_upd>
          {{row['ts_upd'] | date: 'yyyy-MM-dd' }}
        </ng-template>
        <ng-template let-row #ts_del>
          {{row['ts_del'] | date: 'yyyy-MM-dd' }}
        </ng-template>
      </app-kontable>

    </div>
  `
})
export class CustomersAuthAdminFormComponent implements OnChanges {


  @Input() customerAuthData;
  @Output() onBack: EventEmitter<any> = new EventEmitter<any>()

  customerAuth: CustomerAuthModel;
  customerAuthHistory: CustomerAuthHistoryModel[];
  customerAuthTokens: CustomerAuthTokenModel[];

  pt = KontableComponent.ClientPagination;

  loginForm: FormGroup;
  translations: any;

  constructor(
    public svcCustomerAdmin: CustomersAdminService,
    private fb: FormBuilder,
    private notification: MessageService,
    private translate: TranslateService
  ) {

    this.translate.get([
      'customers.auth_message_update_login_ok_detail',
      'customers.auth_message_update_login_ok_summary'
    ]).subscribe(t => {
      this.translations = t;
    })


  }

  reloadData(id) {

    this.svcCustomerAdmin.get(id).subscribe(data => {
      this.customerAuth = data
      this.loginForm = this.fb.group({
        user_account: new FormControl(this.customerAuth.user_account, Validators.required)
      })
    })

    this.svcCustomerAdmin.getHistoryByCustomerAuth(id).subscribe(h => {
      this.customerAuthHistory = h;
    })

    this.svcCustomerAdmin.getTokensByCustomerAuth(id).subscribe(t => {
      this.customerAuthTokens = t
    })
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes['customerAuthData'] && changes['customerAuthData'].currentValue) {
      console.log('customer auth input data', this.customerAuthData)
      this.reloadData(changes['customerAuthData'].currentValue['id'])

    }
  }

  _onBack(data) {
    this.onBack.emit()
  }

  updateLogin() {
    const newLogin = this.loginForm.value['user_account']
    this.svcCustomerAdmin.updateLogin(this.customerAuth.id, newLogin).subscribe(res => {
      this.notification.add({
        severity: 'success',
        detail: 'customers.auth_message_update_login_ok_detail',
        summary: 'customers.auth_message_update_login_ok_sumary'
      })
      this.reloadData(this.customerAuth.id)
    })

  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/admin/customers-auth-admin-form.component.ts